/* eslint-disable @typescript-eslint/naming-convention */
export interface LineItemPickerOptions {
	multipleLineItems?: boolean;
  module: string;
	pickerType: 'modal' | 'popup';
	columns: LineItemPickerColumns[];
	addFromProductGroup?: boolean;
	showMaxQuantityError?: boolean;
  enableOutOfStockProduct?: boolean;
  getCategoryAsObject?: boolean;
	isTaxable?: boolean;
	currentTransactionType?: string;
	data?: [];
	remoteData?: {
		dataUrl: string;
		params?: any;
	};
	filters?: LineItemPickerFilters;
	header: {
		isEnabled: boolean;
		hideCloseIcon?: boolean;
		headerDisplayKey: string;
		headerDisplayName: string;
	};
	footer: {
		isEnabled: boolean;
		hideCountContainer?: boolean;
		buttonDisplayKey: string;
		buttonDisplayName: string;
	};
}

export interface LineItemPickerColumns {
	type: LineItemPickerColumnType;
	multiple?: boolean;
	isEditable: boolean;
	allowAddValue?: boolean;
	isRequired?: boolean;
}

export interface LineItemPickerFilters {
	search?: {
		enabled: boolean;
	};
	location?: {
		enabled: boolean;
		multiple?: boolean;
	};
	productType?: {
		enabled: boolean;
		types: ProductTypes[];
	};
	category?: {
		enabled: boolean;
		multiple?: boolean;
	};
	availability?: {
		enabled: boolean;
	};
}

export interface LineItemModel {
	brand?: string;
  product_image?: string;
	description?: string;
	group_name?: string;
	group_uid?: string;
	meta: any[];
	location_uid: string;
	prefix?: string;
	product_category: string;
	product_description?: string;
	product_id: string;
	product_name: string;
	product_ref_id?: any;
	product_type?: string;
	product_uid: string;
	quantity: number;
	serial_nos?: any[];
	price: number;
	unit_price?: number;
	uom?: any;
	purchase_price?: number;
}

export interface GroupLineItemModel {
	group_uid: string;
	meta: any[];
	price: number;
	unit_price?: number;
	product_category: string;
	product_description: string;
	product_id: string;
	product_manual_link: string;
	product_name: string;
	product_type: string;
	product_uid: string;
	quantity: number;
	tax?: any;
}

export enum LineItemPickerColumnType {
	ID = 'ID',//It's not editable and required by default
	LINE_ITEM = 'LINE_ITEM',//It's not editable and required by default
	CATEGORY = 'CATEGORY',//It's not editable and required by default
	TYPE = 'TYPE',//It's not editable and required by default
	BRAND = 'BRAND',
	SPECIFICATION = 'SPECIFICATION',
	LOCATION = 'LOCATION',
	PURCHASE_PRICE = 'PURCHASE_PRICE',
	MARKUP = 'MARKUP',
	PRICE = 'PRICE',
	QUANTITY = 'QUANTITY',
	SERIAL_NO = 'SERIAL_NO',
	DESCRIPTION = 'DESCRIPTION',
	TAX_PREFERENCE = 'TAX_PREFERENCE',
	TAX_CODE = 'TAX_CODE',
	DISCOUNT = 'DISCOUNT'
}

export const AvailabilityTypes = [{
    displayName: 'Available',
    displayKey: 'text.available',
    value: true
  }, {
    displayName: 'Unavailable',
    displayKey: 'text.unavailable',
    value: false
  }];

export enum ProductTypes {
	PARTS = 'PARTS',
	PRODUCT = 'PRODUCT',
	SERVICE = 'SERVICE',
	BUNDLE = 'BUNDLE',
}
